const navigation = {
    main: [
        { name: 'Services', href: '/' },
        { name: 'About', href: '/about' },
    ],
}

export default navigation;
